/**
 * Ligne d'en-tête au-dessus du titre des fiches backoffice.
 * Format : « {label}{colon}{numéro} | {type} »
 * Le colon a un espace avant uniquement en français (typographie française).
 */
export function formatFormRegistrationReference(
  registrationNumber: string | null | undefined,
  options?: {
    /** Label traduit, ex. t("backoffice.header.registrationNumber.label") */
    label?: string;
    /** Locale courante pour la gestion du deux-points (espace avant en FR uniquement) */
    locale?: string;
    suffix?: string | null;
    /** @deprecated Utiliser suffix à la place */
    trailingDash?: boolean;
  },
): string | undefined {
  const number = registrationNumber?.trim();
  if (!number) {
    return undefined;
  }

  const label = options?.label ?? "N° d'enregistrement";
  const colon = options?.locale?.startsWith("fr") ? " : " : ": ";

  let line = `${label}${colon}${number}`;
  const suffix = options?.suffix?.trim();

  if (suffix) {
    line += ` | ${suffix}`;
  } else if (options?.trailingDash) {
    line += ` -`;
  }

  return line;
}
